<template>
    <v-container class="no-padding-mobile no-padding-top">
        <v-layout>
            <v-flex xs12 sm12 md10 offset-md1 lg10 offset-lg1 xl8 offset-xl2 class="no-padding-top">
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-app-bar-nav-icon>
                            <v-progress-circular
                                :size="28"
                                :width="3"
                                indeterminate
                                color="white"
                                v-if="$apollo.queries.categories.loading"
                            ></v-progress-circular>
                            <v-icon v-else>category</v-icon>
                        </v-app-bar-nav-icon>

                        <v-toolbar-title v-t="'title.categories'"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn rounded dark color="green" @click="addCategory">
                            {{ $t("button.new") }}
                            <v-icon right>add_circle</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text--primary" v-if="errors.length > 0">
                        <v-alert :value="true" type="error" v-for="error in errors" :key="error">{{
                            $t(`error.${error}`)
                        }}</v-alert>
                    </v-card-text>
                    <v-list>
                        <v-list-group
                            v-for="(category, i) in newCategories"
                            :key="i"
                            :value="true"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            v-text="category.name"
                                        ></v-list-item-title>
                                    </v-list-item-content>
                                    <v-chip color="green" text-color="white">{{
                                        $t("label.new")
                                    }}</v-chip>
                                </v-list-item>
                            </template>

                            <v-card>
                                <form @submit.prevent="saveNew(i)">
                                    <v-card-text class="text--primary">
                                        <v-text-field
                                            v-model="category.name"
                                            :label="$t('label.title')"
                                            required
                                            filled
                                            type="text"
                                        ></v-text-field>
                                        <v-textarea
                                            filled
                                            v-model="category.description"
                                            :label="$t('label.description')"
                                        ></v-textarea>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn type="button" @click="closeAll" color>{{
                                            $t("button.cancel")
                                        }}</v-btn>
                                        <v-btn
                                            type="submit"
                                            color="primary"
                                            :disabled="loading"
                                            :loading="loading"
                                            >{{ $t("button.save") }}</v-btn
                                        >
                                    </v-card-actions>
                                </form>
                            </v-card>
                        </v-list-group>
                    </v-list>
                    <v-list>
                        <v-list-group
                            v-for="(category, i) in categories"
                            :key="category._id"
                            v-model="category.active"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            v-text="category.name"
                                        ></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <v-card style="min-height: 300px;">
                                <form
                                    @submit.prevent="saveExisting"
                                    v-if="editing && category.active"
                                >
                                    <v-card-text class="text--primary">
                                        <v-text-field
                                            v-model="editing.name"
                                            :label="$t('label.title')"
                                            required
                                            filled
                                            type="text"
                                        ></v-text-field>
                                        <v-textarea
                                            filled
                                            v-model="editing.description"
                                            :label="$t('label.description')"
                                        ></v-textarea>
                                    </v-card-text>
                                    <v-card-actions>
                                        <BaseDelete @click.stop="remove(i)" :loading="loading" />
                                        <v-spacer></v-spacer>
                                        <v-btn type="button" @click.stop="closeAll" color>{{
                                            $t("button.cancel")
                                        }}</v-btn>
                                        <v-btn
                                            type="submit"
                                            color="primary"
                                            :disabled="loading"
                                            :loading="loading"
                                            >{{ $t("button.save") }}</v-btn
                                        >
                                    </v-card-actions>
                                </form>
                            </v-card>
                        </v-list-group>
                    </v-list>
                    <v-card-text
                        class="text--primary"
                        v-if="newCategories.length <= 0 && categories.length <= 0"
                    >
                        <div class="headline text-xs-center">
                            {{ $t("message.no_categories_yet") }}
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import { mapGetters, mapActions } from "vuex"
import Vue from "vue"
export default {
    mixins: [loadingMixin],
    apollo: {
        categories: {
            query: require("@/graphql/category/categories.gql"),
            update({ categories }) {
                if (this.$route.params.id) {
                    const index = categories.findIndex((c) => c._id == this.$route.params.id)
                    this.editing = Object.assign({}, categories[index])
                    categories[index].active = true
                }
                return categories
            },
            skip() {
                return !this.activated
            },
        },
    },
    methods: {
        async upsert(data) {
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { upsertCategory },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/category/upsertCategory.gql"),
                    variables: {
                        _id: data._id || null,
                        name: data.name,
                        description: data.description,
                    },
                })
                if (upsertCategory) {
                    this.$apollo.queries.categories.refresh()
                    this.$notify({
                        title: this.$i18n.t("notify.updated"),
                        type: "success",
                    })
                }
                this.loading = false
                return upsertCategory
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
        async remove(index) {
            this.loading = true
            const data = this.categories[index]
            this.errors = []
            try {
                const {
                    data: { removeCategory },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/category/removeCategory.gql"),
                    variables: {
                        _id: data._id || null,
                    },
                })

                if (removeCategory) {
                    this.$notify({
                        title: this.$i18n.t("notify.removed"),
                        type: "success",
                    })
                }
                Vue.delete(this.categories, index)
                this.editing = null
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
        async saveNew(index) {
            const upsertCategory = await this.upsert(this.newCategories[index])
            this.categories.push(upsertCategory)
            this.cancelAdding(index)
        },
        async saveExisting() {
            try {
                delete this.editing.active
                const upsertCategory = await this.upsert(this.editing)
                this.activateList(null)
            } catch (error) {}
        },
        cancelAdding(index) {
            Vue.delete(this.newCategories, index)
        },
        addCategory() {
            this.closeAll()
            this.newCategories.push({ name: "", description: "", active: true })
        },
        closeAll() {
            for (const key in this.categories) {
                if (this.categories[key].active) {
                    this.categories[key].active = false
                }
            }
        },
    },
    watch: {
        categories: {
            handler(value) {
                const index = value.findIndex((c) => c.active)
                if (index === -1 && this.$route.params.id) {
                    this.editing = null
                    this.$router.replace({ name: "categories" })
                }
                if (index != -1) {
                    const selected = value[index]
                    if (this.$route.params.id !== selected._id) {
                        this.$router.replace({
                            name: "categories-id",
                            params: { id: selected._id },
                        })
                    }
                    this.editing = selected
                }
            },
            deep: true,
        },
    },
    data() {
        return {
            activeNew: [],
            errors: [],
            editing: null,
            categoryPanel: null,
            rules: {
                required: (value) => !!value || this.$t("error.required"),
            },
            categories: [],
            newCategories: [],
        }
    },
}
</script>
